import styled from "styled-components";

export const NoPaddingPageContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // gap: 140px;
  width: 100vw;
  // padding: 0px 208px;
  box-sizing: border-box;
  overflow: hidden;
  // overflow-y: scroll;
  box-sizing: border-box;
`;

const PageContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 140px;
  width: 100vw;
  padding: 0px 208px;
  box-sizing: border-box;
  overflow: hidden;
  // overflow-y: scroll;
  margin-top: 540px; // dependant on the banner height and responsiveness is also based on banner height
  box-sizing: border-box;
  color: white;

  @media (max-width: 1400px) {
    padding: 0px 160px;
    margin-top: 480px;
  }

  @media (max-width: 1280px) {
    padding: 0px 64px;
    margin-top: 400px;
  }

  @media (max-width: 1024px) {
    padding: 0px 48px;
    margin-top: 360px;
  }

  @media (max-width: 768px) {
    padding: 0px 32px;
    margin-top: 300px;
    gap: 96px;
  }

  @media (max-width: 640px) {
    padding: 0px 24px;
  }

  @media (max-width: 480px) {
    padding: 0px 16px;
    margin-top: 240px;
  }
`;

export default PageContentWrapper;
